import { render, staticRenderFns } from "./VMRSModal.vue?vue&type=template&id=643716c7&"
import script from "./VMRSModal.vue?vue&type=script&lang=js&"
export * from "./VMRSModal.vue?vue&type=script&lang=js&"
import style0 from "./VMRSModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports